<template>
    <div class="box_mt30 black6_link black6_text box_mt40 clearfix2">
        <div class="fl box_pt10">共<span v-text="pagination.total"></span>条记录
            <span class="box_ml40"><b class="blue_text font_22" v-text="params.page">1</b>/<span v-text="pagination.totalPage"></span></span>
        </div>
        <div class="fr page box_c">
            <a href="javascript:void(0);" :class="{disabled:params.page<=1,prev:true,btn:true,china:true}" @click="prePage">&lt;</a>
            <a href="javascript:void(0);" v-for="index in range(inner_start, inner_end)" :key="index" v-text="index" :class="{active:params.page===index}" @click="changePage(index)"></a>
            <a href="javascript:void(0);" :class="{disabled:params.page>=pagination.totalPage,prev:true,btn:true,china:true}" @click="nextPage">&gt;</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        data() {
            return {
                inner_start: this.start,
                inner_end: this.end,
            }
        },
        props: {
            start: {
                type: Number
            },
            end: {
                type: Number
            },
            maxEnd: {
                type: Number,
                default: 5
            },
            pagination: {
                type: Object,
                default() {
                    return {
                        currentPage: 1,
                        rows: 20,
                        total: 100,
                        totalPage: 5
                    }
                }
            },
            params: {
                type: Object,
                default() {
                    return {
                        page: 1,
                        rows: 5
                    }
                }
            }
        },
        methods: {
            range: (start, end) => new Array(end - start + 1).fill(start).map((el, i) => start + i),
            // 修改页数

            // 分页器逻辑
            changePage: function (index) {
                this.params.page = index;
                if (this.pagination.totalPage > this.maxEnd) {
                    if (this.params.page <= Math.round(this.maxEnd / 2)) {
                        this.inner_start = 1;
                        this.inner_end = this.maxEnd
                    } else if (this.params.page >= this.pagination.totalPage - (Math.round(this.maxEnd / 2) - 1)) {
                        this.inner_start = this.pagination.totalPage - (this.maxEnd - 1);
                        this.inner_end = this.pagination.totalPage
                    } else {
                        this.inner_start = index - (Math.round(this.maxEnd / 2) - 1);
                        this.inner_end = index + (Math.round(this.maxEnd / 2) - 1)
                    }
                }
                this.$emit('changeStartAndEnd', this.inner_start, this.inner_end)
            },
            // 前一页
            prePage() {
                if (this.params.page > 1) {
                    this.params.page -= 1;
                    this.changePage(this.params.page)
                }
            },
            // 下一页
            nextPage() {
                if (this.params.page < this.pagination.totalPage) {
                    this.params.page += 1;
                    this.changePage(this.params.page)
                }
            }
        },
        watch: {
            start(val, oldVal) {
                this.inner_start = val
            },
            end(val, oldVal) {
                this.inner_end = val;
            }
        }
    }
</script>

<style scoped>

</style>